import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";
import Confirmation from "CommonComponents/confirmation";
import {
  Button,
} from "react-bootstrap";
import {
  Tooltip,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import {
  getPBPLink,
} from "Apis/massnahme-api";

import _ from "lodash";

@store("user")
@withLocation
export default class AntragAbbruchInfoPopup extends Component {
  openPBPLink(m) {
    const { user, onConfirm } = this.props;
    const link = getPBPLink(m, user);
    if (link) {
      window.open(link);
    }
    onConfirm && onConfirm();
  }

  render() {
    const { onConfirm, antrag } = this.props;

    return (
      <Confirmation
        header='Antrag wurde abgebrochen'
        action='Schließen'
        actionStyle='primary'
        onConfirm={onConfirm}
      >
        <p>Der Antrag wurde abgebrochen.</p>
        <p>Bitte denken Sie daran, die entsprechende(n) Maßnahme(n) in PBP abzubrechen.</p>
        <p>{_.map(antrag.massnahmen, m => <>
          <Tooltip overlay='Zu PBP wechseln und Maßnahme dort anzeigen'>
            <Button variant='outline-primary' onClick={() => this.openPBPLink(m)}>Maßnahme PBP-{m.m_pbpid} in PBP anzeigen</Button>
          </Tooltip>
          <br />
        </>)}</p>
        <br />
      </Confirmation>
    );
  }
}

export class AntragAbbruchPopup extends Component {
  render() {
    const { onCancel, onConfirm } = this.props;
    return (
      <Confirmation
        header='Abbruch bestätigen'
        action='Antrag abbrechen'
        actionStyle='danger'
        onCancel={onCancel}
        onConfirm={onConfirm}
      >
        <p>Sind Sie sicher, dass der Antrag abgebrochen werden soll?</p>
        <p>Wenn der Abbruch stattfindet, müssen Sie die entsprechende Maßnahme(n) in PBP ebenfalls abbrechen.</p>

      </Confirmation>
    );
  }
}

